import React from 'react'

import f1 from "../img/tata.jpg";
import f2 from "../img/krisaj.jpg";
import f3 from "../img/tropical.jpg";
import f4 from "../img/mahindra.jpg";
import f5 from "../img/advanta.jpg";
import f6 from "../img/corveta.jpg";
import f7 from "../img/sulphermill.jpg";
import f8 from "../img/natro.jpg";

const Distrubion = () => {
     const images = [f1, f2, f3, f4, f5, f1, f2, f3, f4, f5 , f6, f7, f8];
  return (
     <>
            <style>
                {`
                    .fertilizer-img {
                        height: 200px !important;
                        width: 300px;
                       
                        border-radius: 0.5rem;
                        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
                    }
                `}
            </style>

            <h2 className="text-center mt-4"> Our Distributorship</h2>
            <div className="overflow-hidden w-full bg-gray-100 py-5">
                <div className="flex gap-4 animate-scroll">
                    {images.map((img, index) => (
                        <div key={index} className="flex-none w-1/4">
                            <img
                                src={img}
                                alt={`Slide ${index + 1}`}
                                className="fertilizer-img"
                            />
                        </div>
                    ))}
                </div>
            </div>


 <br />
            <div>
                <iframe 
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3561.005864355224!2d81.5235634!3d26.8079419!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399a2cb12c48662b%3A0x641ef58b5c640242!2sShanti%20Fertilizers!5e0!3m2!1sen!2sin!4v1740980407131!5m2!1sen!2sin" 
                    width="100%" 
                    height="400" 
                    allowfullscreen="" 
                    loading="lazy" 
                    referrerpolicy="no-referrer-when-downgrade"
                ></iframe>
            </div>
           
        </>
    );
};

export default Distrubion